import {
  BLACK_LISTED_END_PATHS,
  FOOTER_BLACK_LISTED_START_PATHS
} from '~/config/constants';
import {
  pathnameStartsWithRoute,
  pathnameStartsOrEndsWithRoute
} from './router';
import { TranslateFunction } from '~/Locale';

export const showFooter = (t: TranslateFunction, pathname: string) =>
  !pathnameStartsOrEndsWithRoute({
    t,
    pathname,
    startPaths: FOOTER_BLACK_LISTED_START_PATHS,
    endPaths: BLACK_LISTED_END_PATHS
  });

const pathnamesWithoutFooterButtons = [
  '/handelsbanken',
  '/nordea',
  '/wasakredit',
  '/danskefinans',
  '/seb',
  '/sixtleasing',
  '/skanska'
];

export const hideFooterButtons = (t: TranslateFunction, pathname: string) =>
  pathnameStartsWithRoute(t, pathname, 'ROUTES.SELL') ||
  pathnamesWithoutFooterButtons.includes(pathname);
